
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { _common } from './_common';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset.password.error.component.html',
    standalone: true
})
export class ResetPasswordErrorComponent implements OnInit {


  _common = _common;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {

  }

  ngOnInit() {

  }



}
